// extracted by mini-css-extract-plugin
export default {"skeletWrapper":"PromotionsSkelet_skeletWrapper--Ns5","skeletItem":"PromotionsSkelet_skeletItem--Gsd","skeletShimmer":"PromotionsSkelet_skeletShimmer--dtz"};